import { Action } from '@ngrx/store';
import {
  IOcrClaimSubmissionResult,
  IOcrEligibility,
  IOcrSubmitClaimPayload,
  IOcrVerifySubmitClaimPayload,
} from '../../domain/operational-cost-reimbursement.model';

/**
 * SAN-757 — Operational Cost Reimbursement (T-RISE, Slices 1-2). Separate
 * slice, same rationale as `partner-branding`'s: an independent, narrowly
 * scoped feature area, not layered onto an existing generic "startup
 * dashboard" slice.
 */
export enum OcrActionTypes {
  GetEligibility = '[Ocr] GetEligibility',
  GetEligibilitySuccess = '[Ocr] GetEligibilitySuccess',
  GetEligibilityFault = '[Ocr] GetEligibilityFault',

  SubmitClaim = '[Ocr] SubmitClaim',
  SubmitClaimSuccess = '[Ocr] SubmitClaimSuccess',
  SubmitClaimFault = '[Ocr] SubmitClaimFault',

  // BRD FR-5.1 (Slice 4, BRD §21) — Verify & Submit, Month 2 onward.
  // Reuses the SAME `submitting`/`submitSuccess`/`error` reducer fields as
  // SubmitClaim (same semantic: "a claim submission is in flight"), so
  // `getOcrSubmitting`/`getOcrError`/`getOcrSubmitSuccess` all work
  // unchanged for this new flow too — no new selectors needed.
  VerifySubmitClaim = '[Ocr] VerifySubmitClaim',
  VerifySubmitClaimSuccess = '[Ocr] VerifySubmitClaimSuccess',
  VerifySubmitClaimFault = '[Ocr] VerifySubmitClaimFault',
}

export class GetEligibility implements Action {
  readonly type = OcrActionTypes.GetEligibility;
}

export class GetEligibilitySuccess implements Action {
  readonly type = OcrActionTypes.GetEligibilitySuccess;
  constructor(public payload: IOcrEligibility) {}
}

export class GetEligibilityFault implements Action {
  readonly type = OcrActionTypes.GetEligibilityFault;
  constructor(public payload: string) {}
}

export class SubmitClaim implements Action {
  readonly type = OcrActionTypes.SubmitClaim;
  constructor(public payload: IOcrSubmitClaimPayload) {}
}

export class SubmitClaimSuccess implements Action {
  readonly type = OcrActionTypes.SubmitClaimSuccess;
  constructor(public payload: IOcrClaimSubmissionResult) {}
}

export class SubmitClaimFault implements Action {
  readonly type = OcrActionTypes.SubmitClaimFault;
  constructor(public payload: string) {}
}

export class VerifySubmitClaim implements Action {
  readonly type = OcrActionTypes.VerifySubmitClaim;
  constructor(
    public monthIndex: number,
    public payload: IOcrVerifySubmitClaimPayload,
  ) {}
}

export class VerifySubmitClaimSuccess implements Action {
  readonly type = OcrActionTypes.VerifySubmitClaimSuccess;
  constructor(public payload: IOcrClaimSubmissionResult) {}
}

export class VerifySubmitClaimFault implements Action {
  readonly type = OcrActionTypes.VerifySubmitClaimFault;
  constructor(public payload: string) {}
}

export type OcrActions =
  | GetEligibility
  | GetEligibilitySuccess
  | GetEligibilityFault
  | SubmitClaim
  | SubmitClaimSuccess
  | SubmitClaimFault
  | VerifySubmitClaim
  | VerifySubmitClaimSuccess
  | VerifySubmitClaimFault;
